module.exports = __webpack_public_path__ + "static/media/map-marker-slash.f14865bc.svg";